import { Error } from "@components/Error";
import { Loader } from "@components/Loader";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { Message } from "semantic-ui-react";
import { CheckoutModal } from "./CheckoutModal";

export default class ItemsCheckout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      selectedItem: null,
    };
  }

  openCheckout = (item) => {
    this.setState({ showModal: true, selectedItem: item });
  };

  closeCheckout = () => {
    this.setState({ showModal: false, selectedItem: null });
  };

  handleCheckoutConfirm = (itemMetadata, force = false) => {
    const { checkoutItem, patronPid } = this.props;

    const itemPid = {
      type: "pitmid",
      value: itemMetadata.pid,
    };

    checkoutItem(itemMetadata.document_pid, itemPid, patronPid, force);
    this.closeCheckout();
  };

  render() {
    const { isLoading, error, patronData, borrowingStats } = this.props;
    const { showModal, selectedItem } = this.state;

    return (
      <Loader isLoading={isLoading}>
        <Error error={error}>
          <Message color="blue">
            Scan or type the barcode to checkout the physical copy for this
            patron.
          </Message>

          {showModal && selectedItem && (
            <CheckoutModal
              open={showModal}
              onClose={this.closeCheckout}
              onCheckout={this.handleCheckoutConfirm}
              item={selectedItem}
              patronData={patronData}
              borrowingStats={borrowingStats}
            />
          )}
        </Error>
      </Loader>
    );
  }
}

ItemsCheckout.propTypes = {
  error: PropTypes.object,
  isLoading: PropTypes.bool,
  patronData: PropTypes.object,
  borrowingStats: PropTypes.object,
  checkoutItem: PropTypes.func.isRequired,
  patronPid: PropTypes.string,
};

ItemsCheckout.defaultProps = {
  error: null,
  isLoading: false,
  patronData: null,
  borrowingStats: null,
};
